import { atom } from "jotai";

export const updateSampleAtom = atom<boolean>(false);

export interface ICreateDesignRequest {
    brand: string;
    product_id: number;
    art_type: string;
    brand_id: number;
    pricing_template_id: number;
}

export interface ICreateSampleRequest {
    coordinates: {
        x: number;
        y: number;
        width: number;
        height: number;
    };
    design_id: number;
    brand_id: number;
}

export interface ICreateHeaderRequest {
    brand_id: number;
    product_id: number;
    generated_mockup_id: number;
}

export interface IApplyPatternRequest {
    brand_id: number;
    product_id: string;
    mockup_ids: string;
    store_id: string;
}
